import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GamesState, Game } from "../../types";

const initialState: GamesState = {
  playerWaitlist: {},
  playerCurrentGame: {},
  numPlayers: 0,
  currentGame: {},
  publicCashList: null,
  publicTourneyList: null,
  privateCashList: null,
  privateTourneyList: null,
};

const gamesSlice = createSlice({
  name: "games",
  initialState,
  reducers: {
    setPublicCashList: (state, action: PayloadAction<Record<string, Game>>) => {
      state.publicCashList = action.payload;
    },
    setPublicTourneyList: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.publicTourneyList = action.payload;
    },
    setPrivateCashList: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.privateCashList = action.payload;
    },
    setPrivateTourneyList: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.privateTourneyList = action.payload;
    },
    setPlayerWaitlist: (state, action: PayloadAction<Record<string, Game>>) => {
      state.playerWaitlist = action.payload;
    },
    setPlayerCurrentGame: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.playerCurrentGame = action.payload;
    },
    setNumPlayersList: (state, action: PayloadAction<number>) => {
      state.numPlayers = action.payload;
    },
  },
});

export const {
  setPublicCashList,
  setPublicTourneyList,
  setPrivateCashList,
  setPrivateTourneyList,
  setPlayerWaitlist,
  setPlayerCurrentGame,
  setNumPlayersList,
} = gamesSlice.actions;
export default gamesSlice.reducer;
